import * as React from 'react';
import { ErrorHandlerProps } from '../../../../controllers/errorHandler/ErrorHandlerProps';

export const ErrorHandlerContext = React.createContext<ErrorHandlerProps>({
  errorHandlers: undefined,
});
ErrorHandlerContext.displayName = 'ErrorHandlerContext';
